import { v4 as uuidv4 } from "uuid";
import { Protocol } from "../../../protocol";
import { NoteBlock } from "../block";

export interface ProtocolBlock extends NoteBlock {
  "protocol-id": string;
  type: "omega/query-omega/page/block/protocol/ProtocolBlock";
}

export function isProtocolBlock(block: NoteBlock): block is ProtocolBlock {
  return (block as ProtocolBlock)["protocol-id"] !== undefined;
}

export const newProtocolBlock = (config: {
  proto: Protocol;
  blockIndex: number;
}) => {
  const { blockIndex, proto } = config;
  const block: ProtocolBlock = {
    "protocol-id": proto["protocol-id"],
    type: "omega/query-omega/page/block/protocol/ProtocolBlock",
    "block-index": blockIndex,
    "page-id": proto["page-id"],
    "app-id": proto["app-id"],
    "block-id": uuidv4(),
  };
  return block;
};
